import React from "react";
import { AbsoluteFill } from "remotion";
import { LOOK } from "../../b2c/look";
import { FrakLogo } from "../../components/FrakLogo";
import { frTypo } from "../../lib/frTypo";

/** Facebook page cover at 2x of 820x312. */
export const FACEBOOK_BANNER = { width: 1640, height: 624 } as const;

/**
 * The landing hero promise, verbatim (same line as the B2C end card,
 * `b2c/copy` cta.line1 + line2), with a typographic apostrophe. Nothing
 * else is claimed.
 */
const LINES = ["Gagne de l’argent", "en recommandant", "ce que tu aimes"].map(
  frTypo,
);

/**
 * Safe zone: Facebook crops the cover to the central ~1109px on mobile and
 * the profile picture overlaps the bottom-left on desktop, so logo and text
 * sit in one centred column (well inside the central 1000px, 60px from top
 * and bottom). Only the background bars reach the edges.
 */
export const FacebookBanner: React.FC = () => {
  return (
    <AbsoluteFill
      style={{
        background: `radial-gradient(120% 90% at 50% 0%, ${LOOK.blue} 55%, ${LOOK.blueDeep} 100%)`,
        alignItems: "center",
        justifyContent: "center",
        overflow: "hidden",
      }}
    >
      {/* Decoration only: the Frak bars, bleeding off the corners. */}
      <FrakLogo
        variant="icon"
        width={440}
        color={LOOK.blueSoft}
        style={{ position: "absolute", top: -90, left: -130, opacity: 0.16 }}
      />
      <FrakLogo
        variant="icon"
        width={440}
        color={LOOK.blueSoft}
        style={{ position: "absolute", bottom: -110, right: -130, opacity: 0.16 }}
      />

      {/* The shipped SVG is brand blue; flip it to white on blue. */}
      <FrakLogo
        width={200}
        style={{ filter: "brightness(0) invert(1)", marginBottom: 32 }}
      />
      <div
        style={{
          fontFamily: LOOK.display,
          fontWeight: LOOK.bold,
          fontSize: 100,
          lineHeight: 1.05,
          letterSpacing: -2.5,
          wordSpacing: 6,
          color: LOOK.white,
          textAlign: "center",
        }}
      >
        {LINES.map((line) => (
          <div key={line} style={{ whiteSpace: "nowrap" }}>
            {line}
          </div>
        ))}
      </div>
    </AbsoluteFill>
  );
};
